/**
 * TruSpace logo mark — circular primary badge (AI FAB, chat avatar, reports toggle).
 */
import { cn } from '@/lib/cn';

const TRUSPACE_ICON_SRC = '/logo-ts-icon.png';

const SIZES = {
  sm: { shell: 'h-6 w-6', img: 'h-4 w-4' },
  md: { shell: 'h-7 w-7', img: 'h-5 w-5' },
  fab: { shell: 'h-13 w-13', img: 'h-8 w-8' },
} as const;

export type TruSpaceIconBadgeSize = keyof typeof SIZES;

interface TruSpaceIconBadgeProps {
  size?: TruSpaceIconBadgeSize;
  /** Logo only — use when the parent is already `bg-primary`. */
  plain?: boolean;
  className?: string;
}

/** TruSpace icon in the same circular primary treatment as the AI floating button. */
export function TruSpaceIconBadge({
  size = 'sm',
  plain = false,
  className,
}: TruSpaceIconBadgeProps) {
  const { shell, img } = SIZES[size];
  const logo = (
    <img src={TRUSPACE_ICON_SRC} alt="" aria-hidden className={cn(img, 'object-contain')} />
  );

  if (plain) {
    return (
      <span className={cn('flex shrink-0 items-center justify-center', shell, className)}>{logo}</span>
    );
  }

  return (
    <span
      className={cn(
        'flex shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground',
        shell,
        className,
      )}
    >
      {logo}
    </span>
  );
}
